export default __webpack_public_path__ + "static/living-church-header-logo-c6f647236ff20cb203a55bf19f93ac2f.svg";